import { createSlice } from '@reduxjs/toolkit'
import { resetAllReduxStates } from './resetAllReduxStatesAction'
const initialState = {
  loading: false,
  hasErrors: false,
  salesPersonId: null,
  companyNameOptions: [],
  projectNameOptions: [],
}
const accountNameEntitiesSlice = createSlice({
  name: 'accountNameEntities',
  initialState,
  reducers: {
    getAccountNameEntities: (state) => {
      state.loading = true
      state.hasErrors = false
    },
    setAccountantNameEntitites: (state, { payload }) => {
      state.salesPersonId = payload.salesPersonId
      state.companyNameOptions = payload.company ?? []
      state.projectNameOptions = payload.project ?? []
      state.loading = false
      state.hasErrors = false
    },
    getAccountNameEntitiesFailure: (state) => {
      state.loading = false
      state.hasErrors = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetAllReduxStates, () => initialState)
  },
})

export const {
  getAccountNameEntities,
  setAccountantNameEntitites,
  getAccountNameEntitiesFailure,
} = accountNameEntitiesSlice.actions

export const accountNameEntitiesSelector = (state) => state.accountNameEntities

export default accountNameEntitiesSlice.reducer
